import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchCategoryWiseProductAPI(id) {
    const response = await fetch(`${baseURL}/api/product/category/${id}?with_products=1`);
    if(!response.ok) throw new error("Failed to retch category wise product data");
    return response.json()
}